import IconeDivergencia from '@/components/IconeDivergencia';
import IconeRessalva from '@/components/IconeRessalva';
import OrdemPreSessao from '@/components/OrdemPreSessao';
import ApmVars from '@/util/ApmVars';
import SentryUtil from '@/util/SentryUtil';
import { Warning } from '@mui/icons-material';
import IconeAnotacoes from '@mui/icons-material/Notes';
import { Box, Stack, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/listaProcessos.css';
import Configuracao from '../../util/Configuracao';
import IconeOrigem from '../IconeOrigem';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import ReactComponent from '../ReactComponent';
import AnotacaoCurtaSecretario from './AnotacaoCurtaSecretario';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import Impedimento from './Impedimento';
import OrdemSecretario from './OrdemSecretario';
import ParticipacaoAdvogado from './ParticipacaoAdvogado';
import PeticoesPendentes from './PeticoesPendentes';
import ResultadoJulgamento from './ResultadoJulgamento';
import StatusMinuta from './StatusMinuta';
import ValidacaoPreSessao from './ValidacaoPreSessao';
import VotoRevogado from './VotoRevogado';
import IconeCorreJunto from './icones/IconeCorreJunto';
import IconeDestaque from './icones/IconeDestaque';
import IconeTipoJulgamento from './icones/IconeTipoJulgamento';

class CabecalhoProcessoPreSessao extends ReactComponent {
    acabouDeClicarEmFecharVistaEmMesa = false;
    abrirPopoverVistaMesa = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            acabouDeClicarEmFecharVistaEmMesa: observable,
            abrirPopoverVistaMesa: observable,
            registro: computed,
            processo: computed,
            handleClickObservacao: action,
            origemPJe: computed,
            handleExpandClick: action,
            renderAlertas: computed,
            renderOrdemPreSessao: computed,
            renderNumeroProcesso: computed,
            renderMagistradosProcesso: computed,
            renderToolbarParticipacaoAdvogado: computed,
            renderIcones: computed,
            renderAnotacoes: computed,
            renderAnotacaoCurtaEOrdemSecretario: computed,
            renderValidacaoPreSessao: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    handleClickObservacao = () => {
        this.store.processoExpandido = this.registro;
    };

    get origemPJe() {
        return this.registro?.processo?.origem === Configuracao.ORIGEM_PJE;
    }

    handleExpandClick = (event) => {
        if (this.registro?.numeroProcesso) {
            ApmVars.setTagNumeroProcesso(this.registro.numeroProcesso);
            SentryUtil.setScope();
        }

        if (event.target.dataset.expand) {
            if (this.store.processoExpandido === this.registro) {
                const elemento = document.querySelector('#detalhes-processo');

                if (elemento !== null) {
                    elemento.focus();
                }
            }

            this.store.processoExpandido = this.registro;
        }
    };

    render() {
        return (
            <Box
                data-expand
                onClick={this.handleExpandClick}
                style={{ display: 'flex', flexDirection: 'column', margin: '0px 5px 5px 5px', marginTop: '4px' }}
            >
                <div
                    data-expand
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        fontSize: '11pt',
                        marginBottom: '6px',
                        lineHeight: 2.5
                    }}
                >
                    {this.renderOrdemPreSessao}
                    {this.renderAlertas}
                    {this.renderNumeroProcesso}
                    {this.renderToolbarParticipacaoAdvogado}
                    <div
                        data-expand
                        style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between', width: '100%' }}
                    >
                        {this.renderMagistradosProcesso}
                        <div
                            data-expand
                            style={{ display: 'flex', flexWrap: 'wrap' }}
                        >
                            {this.renderAnotacaoCurtaEOrdemSecretario}
                            {this.renderAnotacoes}
                        </div>
                    </div>
                    <Stack
                        width="100%"
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        data-expand
                    >
                        {this.renderIcones}
                        {this.renderValidacaoPreSessao}
                    </Stack>
                </div>
            </Box>
        );
    }

    get renderAlertas() {
        const alertas = [];
        let cor = 'darkorange';

        if (this.registro.localIncompativelJulgamento) {
            alertas.push('Local do processo: ' + this.registro.localIncompativelJulgamento + '.');
            cor = 'darkred';
        }

        if (this.registro.necessitaImportacaoSalaSessao) {
            alertas.push('Processo não importado para sala de sessão.');
        }

        return (
            alertas.length > 0 && (
                <div style={{ height: '26px', marginLeft: '8px' }}>
                    <Tooltip
                        title={alertas.join(' ')}
                        placement="top"
                    >
                        <Warning style={{ fill: cor }} />
                    </Tooltip>
                </div>
            )
        );
    }

    get renderOrdemPreSessao() {
        return <OrdemPreSessao ordem={this.registro.ordemPreSessao} />;
    }

    get renderNumeroProcesso() {
        return (
            <span style={{ width: '300px', marginLeft: '8px' }}>
                <LabelNumeroProcesso
                    habilitarCopiarNumero
                    registro={this.registro}
                />
            </span>
        );
    }

    get renderMagistradosProcesso() {
        return <IconesMagistradosProcesso registro={this.registro} />;
    }

    get renderToolbarParticipacaoAdvogado() {
        return (
            <div style={{ width: '130px', marginLeft: '10px' }}>
                <ParticipacaoAdvogado registro={this.registro} />
            </div>
        );
    }

    get renderIcones() {
        return (
            <>
                <div style={{ display: 'flex', alignItems: 'center', width: '36px' }}>
                    {!!this.parametroStore?.isOrgaoTST && <IconeOrigem processo={this.processo} />}
                </div>
                <Impedimento registro={this.registro} />
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <PeticoesPendentes registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <IconeDestaque registro={this.registro} />
                </div>
                <div style={{ height: '28px', width: '28px', marginLeft: '8px' }}>
                    <IconeTipoJulgamento
                        permiteAlterar={true}
                        registro={this.registro}
                    />
                </div>
                <div style={{ height: '28px', width: '28px', marginLeft: '8px' }}>
                    <ResultadoJulgamento registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <IconeCorreJunto processo={this.processo} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <StatusMinuta registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeRessalva registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeDivergencia registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <VotoRevogado registro={this.registro} />
                </div>
            </>
        );
    }

    get renderAnotacoes() {
        return (
            <div
                style={{
                    marginLeft: '5px',
                    width: '26px',
                    height: this.registro.informacaoProcessoSalaSessao?.complementoAnotacoes ? 'auto' : '0px'
                }}
            >
                {!!this.registro.informacaoProcessoSalaSessao?.complementoAnotacoes && (
                    <Tooltip title={'Anotações: ' + this.registro.informacaoProcessoSalaSessao.complementoAnotacoes}>
                        <span>
                            <IconeAnotacoes
                                style={{ fillOpacity: '0.4' }}
                                onClick={this.handleClickObservacao}
                            />
                        </span>
                    </Tooltip>
                )}
            </div>
        );
    }

    get renderAnotacaoCurtaEOrdemSecretario() {
        return (
            this.registro.sessaoId && (
                <>
                    <div style={{ marginLeft: '5px' }}>
                        <AnotacaoCurtaSecretario
                            registro={this.registro}
                            componenteExibicao="CabecalhoProcessoPreSessao"
                        />
                    </div>
                    <div style={{ marginLeft: '5px' }}>
                        <OrdemSecretario
                            registro={this.registro}
                            componenteExibicao="CabecalhoProcessoPreSessao"
                        />
                    </div>
                </>
            )
        );
    }
    get renderValidacaoPreSessao() {
        return (
            this.registro.sessaoId && (
                <div style={{ marginLeft: '0px' }}>
                    <ValidacaoPreSessao registro={this.registro} />
                </div>
            )
        );
    }
}

export default inject('stores')(observer(CabecalhoProcessoPreSessao));
